import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-roundabout-right', 'ArrowRoundaboutRight', [["path",{"d":"M21 9h-8a5 5 0 1 0 -5 5v7"}],["path",{"d":"M17 5l4 4l-4 4"}]]);